import { Static, Type } from "@sinclair/typebox";

export const CartPersonaSchema = Type.Object({
  id: Type.String(),
  name: Type.String(),
  membershipNumber: Type.Optional(Type.String()),
});
export type CartPersona = Static<typeof CartPersonaSchema>;
